import { render, staticRenderFns } from "./ComissaoAlelo.vue?vue&type=template&id=097ea11f&scoped=true"
import script from "./ComissaoAlelo.vue?vue&type=script&lang=js"
export * from "./ComissaoAlelo.vue?vue&type=script&lang=js"
import style0 from "./ComissaoAlelo.vue?vue&type=style&index=0&id=097ea11f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097ea11f",
  null
  
)

export default component.exports